export const RESET_BUTTON_SX = {
  textTransform: 'none',
  fontSize: '0.75rem',
  fontWeight: 500,
  backgroundColor: 'rgba(211, 47, 47, 0.08)',
  '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.12)' }
};

export default {
  RESET_BUTTON_SX,
};
